import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { COUNTRY_CALLING_CODES, DEFAULT_COUNTRY_CALLING_CODE } from 'src/app/constants/country-calling-codes';

@Component({
  selector: 'country-code-select',
  templateUrl: './country-code-select.component.html',
  styleUrls: ['./country-code-select.component.scss']
})
export class CountryCodeSelectComponent implements OnInit {

  @Output() change: EventEmitter<string> = new EventEmitter();

  @ViewChild('select', { static: true }) select: ElementRef;

  // inputs
  @Input() label: string = 'Country Code';
  @Input() showLabel: boolean = true;
  @Input() required: boolean = true;
  @Input() fieldError: string;
  @Input() isSubmitted: boolean;

  // options data
  options = COUNTRY_CALLING_CODES;

  constructor(
    @Self() public ngCtrl: NgControl
  ) {
    ngCtrl.valueAccessor = this;
  }

  ngOnInit(): void {
    if (!this.select.nativeElement.value) {
      this.select.nativeElement.value = DEFAULT_COUNTRY_CALLING_CODE;
    }
  }

  onSelectChange(value: string): void {
    this.onChange(value);
    this.change.emit(value);
  }

  onChange(_value: string) {}

  onTouched() {}

  writeValue(value: string) {
    const dialCode = value || DEFAULT_COUNTRY_CALLING_CODE;
    this.select.nativeElement.value = dialCode;
    // the options may not be rendered yet the first time the control writes its
    // initial value, so set it again once this change detection pass is done
    setTimeout(() => {
      this.select.nativeElement.value = dialCode;
    });
  }

  registerOnChange(fn: (value: string) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

}
